import { i18n } from "@/i18n";
import { analyticsTagsConstantes } from "@/constantes/analyticsTags";

export default {
  path: "/registration",
  name: "Registration",
  component: () => import(/* webpackChunkName: "training" */ "@/views/Training/LayoutView.vue"),
  redirect: { name: "TrainingList" },
  meta: {
    breadcrumb: true,
    authRequired: true,
    title: i18n.global.t("page.training_list"),
  },
  children: [
    {
      path: ":group/show/:tab/:registration?",
      name: "TrainingPreRegistration",
      component: () =>
        import(/* webpackChunkName: "registration" */ "@/views/Registration/PreRegistrationSheetView.vue"),
      meta: {
        authRequired: true,
        title: i18n.global.t("page.pre_registration"),
        breadcrumb: true,
        displayTrainingName: true,
      },
    },
    {
      path: ":group/create",
      name: "TrainingCreatePreRegistration",
      component: () =>
        import(/* webpackChunkName: "registration" */ "@/views/Registration/PreRegistrationSheetCreateView.vue"),
      meta: {
        title: i18n.global.t("registration.group_action.create"),
        authRequired: false,
        breadcrumb: true,
        displayTrainingName: true,
      },
    },
    {
      path: "dashboard",
      name: "RegistrationLayoutView",
      redirect: { name: "RegistrationDashboard" },
      component: () => import(/* webpackChunkName: "registration" */ "@/views/Registration/RegistrationLayoutView.vue"),
      meta: {
        title: i18n.global.t("page.registration_dashboard"),
        breadcrumb: true,
        authRequired: true,
      },
      children: [
        {
          path: "",
          name: "RegistrationDashboard",
          component: () =>
            import(/* webpackChunkName: "registration" */ "@/views/Registration/RegistrationDashboardView.vue"),
          meta: {
            title: i18n.global.t("page.registration_dashboard"),
            breadcrumb: false,
          },
        },
        {
          path: "list",
          name: "RegistrationList",
          component: () =>
            import(/* webpackChunkName: "registration" */ "@/views/Registration/RegistrationsListView.vue"),
          meta: {
            title: i18n.global.tc("global.list.title", 1, {
              name: i18n.global.tc("studea_manager.registration.title", 2).toLowerCase(),
            }),
            breadcrumb: true,
            trackPageView: true,
            trackPageViewTagId: analyticsTagsConstantes.PILOT_DASHBOARD_REGISTRATION,
          },
        },
        {
          path: "trainings",
          name: "RegistrationTrainingList",
          component: () => import(/* webpackChunkName: "training" */ "@/views/Training/TrainingListView.vue"),
          meta: {
            title: i18n.global.t("page.training_list"),
            breadcrumb: true,
          },
        },
        {
          path: "alerts",
          name: "RegistrationAlertList",
          component: () =>
            import(/* webpackChunkName: "registration" */ "@/views/Registration/Alert/RegistrationAlertListView.vue"),
          meta: {
            title: i18n.global.tc("global.list.title", 1, {
              name: i18n.global.tc("registration.alert.title", 2).toLowerCase(),
            }),
            breadcrumb: true,
          },
        },
        {
          path: "group",
          name: "RegistrationGroup",
          component: () => import(/* webpackChunkName: "global" */ "@/views/Global/GlobalLayoutView.vue"),
          meta: {
            title: i18n.global.tc("global.list.title", 1, {
              name: i18n.global.tc("studea_manager.group.title", 2).toLowerCase(),
            }),
            breadcrumb: true,
          },
          children: [
            {
              path: "list",
              name: "RegistrationGroupList",
              component: () => import(/* webpackChunkName: "training" */ "@/views/Training/TrainingGroupListView.vue"),
              meta: {
                title: i18n.global.tc("global.list.title", 1, {
                  name: i18n.global.tc("studea_manager.group.title", 2).toLowerCase(),
                }),
                breadcrumb: false,
              },
            },
            {
              path: "add/:trainingCourseId",
              name: "RegistrationGroupAdd",
              component: () =>
                import(/* webpackChunkName: "training" */ "@/views/Training/TrainingGroupAddEditView.vue"),
              meta: {
                title: i18n.global.tc("global.add.title", 1, {
                  name: i18n.global.tc("studea_manager.group.title", 1).toLowerCase(),
                }),
                breadcrumb: true,
                displayTrainingName: true,
              },
            },
            {
              path: "edit/:id",
              name: "RegistrationGroupEdit",
              component: () =>
                import(/* webpackChunkName: "training" */ "@/views/Training/TrainingGroupAddEditView.vue"),
              meta: {
                title: i18n.global.tc("global.edit.title", 1, {
                  name: i18n.global.tc("studea_manager.group.title", 1).toLowerCase(),
                }),
                breadcrumb: true,
                displayTrainingName: true,
              },
            },
          ],
        },
        {
          path: "apprentice",
          name: "RegistrationApprentice",
          redirect: { name: "RegistrationApprenticeList" },
          component: () => import(/* webpackChunkName: "global" */ "@/views/Global/GlobalLayoutView.vue"),
          meta: {
            title: i18n.global.tc("global.list.title", 1, {
              name: i18n.global.tc("studea_manager.apprentice.title", 2).toLowerCase(),
            }),
            breadcrumb: true,
          },
          children: [
            {
              path: "list",
              name: "RegistrationApprenticeList",
              component: () =>
                import(/* webpackChunkName: "registration" */ "@/views/Registration/Apprentice/ApprenticeListView.vue"),
              meta: {
                title: i18n.global.tc("global.list.title", 1, {
                  name: i18n.global.tc("studea_manager.apprentice.title", 2).toLowerCase(),
                }),
                breadcrumb: false,
              },
            },
            {
              path: "edit/:id",
              name: "RegistrationApprenticeEdit",
              component: () =>
                import(
                  /* webpackChunkName: "registration" */ "@/views/Registration/Apprentice/ApprenticeAddEditView.vue"
                ),
              meta: {
                title: i18n.global.tc("global.edit.title", 2, {
                  name: i18n.global.tc("studea_manager.apprentice.title", 1).toLowerCase(),
                }),
                breadcrumb: true,
              },
            },
          ],
        },
        {
          path: "insee-company",
          name: "RegistrationCompany",
          redirect: { name: "RegistrationCompanyList" },
          component: () => import(/* webpackChunkName: "global" */ "@/views/Global/GlobalLayoutView.vue"),
          meta: {
            title: i18n.global.tc("global.list.title", 2, {
              name: i18n.global.tc("studea_manager.company.title", 2).toLowerCase(),
            }),
            breadcrumb: true,
          },
          children: [
            {
              path: "list",
              name: "RegistrationCompanyList",
              component: () =>
                import(
                  /* webpackChunkName: "registration" */ "@/views/Registration/InseeCompany/InseeCompanyListView.vue"
                ),
              meta: {
                title: i18n.global.tc("global.list.title", 1, {
                  name: i18n.global.tc("studea_manager.company.title", 2).toLowerCase(),
                }),
                breadcrumb: false,
              },
            },
            {
              path: "view/:id",
              name: "RegistrationCompanyView",
              component: () =>
                import(
                  /* webpackChunkName: "registration" */ "@/views/Registration/InseeCompany/InseeCompanyViewView.vue"
                ),
              meta: {
                title: i18n.global.tc("global.view.title", 2, {
                  name: i18n.global.tc("studea_manager.company.title", 1).toLowerCase(),
                }),
                breadcrumb: true,
              },
            },
          ],
        },
        {
          path: "invoice",
          name: "RegistrationInvoice",
          component: () => import(/* webpackChunkName: "registration" */ "@/views/Global/GlobalLayoutView.vue"),
          redirect: { name: "RegistrationScheduleInvoiceListView" },
          meta: {
            title: i18n.global.tc("global.list.title", 1, {
              name: i18n.global.tc("registration.invoice.schedule.title", 2).toLowerCase(),
            }),
            breadcrumb: false,
          },
          children: [
            {
              path: "schedule/list",
              name: "RegistrationScheduleInvoiceListView",
              component: () =>
                import(
                  /* webpackChunkName: "registration" */ "@/views/Registration/Invoice/ScheduleInvoiceListView.vue"
                ),
              meta: {
                title: i18n.global.tc("global.list.title", 1, {
                  name: i18n.global.tc("registration.invoice.schedule.title", 2).toLowerCase(),
                }),
                breadcrumb: true,
              },
            },
            {
              path: "list",
              name: "RegistrationInvoiceListView",
              component: () =>
                import(/* webpackChunkName: "registration" */ "@/views/Registration/Invoice/InvoiceListView.vue"),
              meta: {
                title: i18n.global.tc("global.list.title", 1, {
                  name: i18n.global.tc("registration.invoice.title", 2).toLowerCase(),
                }),
                breadcrumb: true,
              },
            },
          ],
        },
      ],
    },
  ],
};
